import React from "react";
// import arrows from "../../../../../../../Assets/Images/arrows.svg";
// import leftArrow from "../../../../../../../Assets/Images/v-arrow.svg";
import "./style.css";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";

const Table = ({ data, activePage, handlePageChange }) => {
  return (
    <React.Fragment>
      <p className="fw-semibold">List of students with pending submissions</p>
      <div className="submission-table card  my-4 border-0">
        <div className="row">
          <div className="col-12 mx-auto">
            <div className="detail-table">
              <div className="table mb-0">
                <table className="table border mb-0">
                  <tbody>
                    {data?.data?.map((item, key) => {
                      return (<tr key={key}>
                        <td className="py-3 px-4">
                          {item?.name}
                        </td>
                        {/* <td className="py-3 px-4 text-center">
                          Activity 1, activity 2
                        </td> */}
                        <td className="py-3 px-4 text-center">{item?.submittedCount}/{item?.totalSubmission} submission</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
              {data?.pagination_info &&
                <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
                  <p className="counting mb-0">{activePage} out of {data?.pagination_info?.total_pages}</p>
                  <nav aria-label="Page navigation example">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={data?.pagination_info?.page_size}
                      totalItemsCount={data?.pagination_info?.total_elements}
                      pageRangeDisplayed={5}
                      innerClass="pagination mb-0 p-0"
                      itemClass="page-item"
                      linkClass="page-link"
                      onChange={handlePageChange}
                    />
                  </nav>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Table;
